import React, { PropTypes } from 'react'
import styles from './FilterIcon.scss'

export const FilterIcon = ({ iconValue: { color, icon } }) => (
	<div className={styles.icon} style={{backgroundColor: color}}>
		<img src={icon}/>
	</div>
)
FilterIcon.propTypes = {
    iconValue: PropTypes.object,
}



// WEBPACK FOOTER //
// ./components/easinsure/contracts/FilterIcon.jsx